
export const borderedTicketStyle = `
<style>
	@page{
		/*margin: auto 1mm auto 1mm;*/
	
	}
	
	.bordered-ticket-container{
		/*width: calc(100% - 1500px);*/
	    min-width: 260px;
	    max-width: 300px;
	    background-color: white;
	    color: black;
	    font-family: Arial, Helvetica, sans-serif;
	    padding-left: 0px;
	    padding-right: 0px;
	    padding-bottom: 20px;
	    height: auto;
	    float: left;
	    margin: 0px;
	    text-align:center;
	    font-size: 13px;
	}
	
	.border-bottom{
		border-bottom-style: solid!important;
    	border-bottom-width: 1px!important;
	}
	
	.customer-logo-container img{
	    height: auto;
	    max-height: 100px;
	    width: 95%;
	    min-width: 160px;
   		max-width: 160px;
   		margin-top:2%;
	}
	.customer-logo-container.footer img{
	    height: auto;
	    max-height: 100px;
	    width: 95%;
	    min-width: 190px;
   		max-width: 190px;
   		margin-top:1%;
	}
	
	.barcode-container img{
	    height: 40px!important;
	    width: 95%!important;
	    display:initial!important;
	    margin-top: 4%;
	}
	
	.qrcode-container{
		display: grid;
    	justify-content: center;
	}	
	.aams-logo-container{
		margin-top:1%;
	}
	
	.aams-logo-container img{
	    height: auto;
	    max-width: 150px;
	    max-height: 100px;
	    width: auto;
	}
	
	.text-container{
		margin-top:2%;
		font-size: 16px;
		display:inline-block;
	}
	
	.text-container-aams{
		margin-top:2%;
		font-size: 10px;
		display:inline-block;
		font-weight:bold;
		width:70%;
	}
	
	.div-table{
		/*margin-top:4%;*/
		border-style: solid;
	    border-color: black;
	    border-width: 1px;
	    border-bottom:none;
	}
	
	.metadata-subtable{
		
	}
	.metadata-row{
		text-align:center;
		font-size: 12px;
		padding-top: 1%;
    	padding-bottom: 1%;
	}
	
	.metadata-key{
		font-weight:bold;
		float:left;
		margin-left:5px;
	}
	.metadata-value{
		float:right;
		margin-right: 5px;
	}

	.potWin {
		font-size:13px;
		font-weight:bold;	
	}
	
	.clear{
		clear: both;
	}
	
	
	.ticket-type-subtable{
		margin-top:2%;
		margin-bottom:1%;
	}
	
	.ticket-type-row{
		font-weight:bold;
		font-size: 17px;
	}
	.table-line{
		border-top-style: solid;
	    border-top-color: black;
	    border-top-width: 1px;
	    padding-top:1%;
	}
	
	.event-row{
		text-align:center;
		font-size: 8px;
		padding-top:0.5px;
	}
	
	.event-row-left{
		float:left;
		margin-left:5px;
	}
	.event-row-right{
		float:right;
		margin-right: 5px;
	}
	
	.event-code{
		font-size:8px;
		font-weight:bold;
	}
	
	.draw{
		font-weight:bold;
		margin-left:5px;
	}
	
	.event-name{
		font-weight:bold;
		font-size:10px;
	}
	.combination-table{
		width:97%;
		font-size: 11px;
	}
	
	.hide{
		display:none;
	}
	
	.ellipsis-if-overflow{
		max-width: 190px;
	    overflow: hidden;
   		white-space: nowrap;
   		text-overflow:ellipsis;
	}
	
	.banker{
	    margin-right: 2px;
	    border-style: ridge;
	    border-width: 1px;
	    border-color: black;
	    font-size: 9px;
	    float: left;
	   	margin-top: -1px;
	}
	
	.system-legend{
		font-size: 9px;
	    font-weight: bold;
	    border-style: solid;
	    border-width: 1px;
	    padding-top: 1%;
	    border-bottom: none;
	}
	
	.system-legend  .banker{
		float:initial!important;
	}
	
	.star{
		font-size:15px;
	}
	
	
	.line-separator{
		margin-top:8px;
	}
	
	.bold{
		font-weight:bold;
	}
	
	.font-size10{
		font-size:10px;
	}
	
	.companyName{
		padding-top: 1%;
	    padding-bottom: 1%;
	    font-size: 12px;
	    font-weight: bold;
    }
</style>
`;


export const plainTicketStyle = `
<style>
	.td-10{
		width: 10%;
	}
	
	.td-15{
		width: 15%;
	}
	
	.td-20{
		width: 20%;
	}
	
	.td-25{
		width: 25%;
	}
	
	.td-30{
		width: 30%;
	}
	
	.td-33{
		width: 33%;
	}
	
	.td-35{
		width: 35%;
	}
	
	.td-40{
		width: 40%;
	}
	
	.td-50{
		width: 50%;
	}
	
	.td-60{
		width: 60%; 
	}
	
	.td-65{
		width: 65%; 
	}
	
	.td-66{
		width: 66%;
	}
	
	.td-70{
		width: 70%;
	}
	
	.td-75{
		width: 75%;
	}
	
	.td-80{
		width: 80%;
	}
	
	.td-85{
		width: 85%;
	}
	
	.td-100{
		width: 100%;
	}
	
	.left{
		float: left;
	}
	
	.right{
		float: right;
	}
	
	.center{
		text-align: center;
	}
	
	.textleft{
		text-align: left;
	}
	.textcenter{
		text-align: center;
	}
	.textright{
		text-align: right;
	}
	
	.bold{
		font-weight: bold;
	}
	
	.uppercase{
		text-transform: uppercase;
	}
	
	.hide{
		display: none;
	}
	
	.truncate_tournament_descr {
	  width: 218px;
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	}
	
	.truncate_tournament_descr_sistemi {
	  width: 208px!important;
	}
	
	.truncate_event_descr {
	  /*width: 198px;*/
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: inline-block;
	  width: 56%;
	}
	
	.ticket-container {
	    width: calc(100% - 20px);
	    min-width: 265px;
	    background-color: white;
	    color: black;
	    font-family: Arial, Helvetica, sans-serif;
	    font-size: 11px;
	    padding-left: 0px;
	    padding-right: 0px;
	    padding-bottom: 20px;
	    height: auto;
	    float: left;
	    margin: 0px;
	}
	
	
	#header_codicebarre{
		padding: 5px 0 5px 0;
	}
	
	
	#header-logos{
		display:flex;
		justify-content:center;
	}
	#customer-logo{
		width: 47%;	
		display:flex;
	}
	
	#customer-logo-solo{
		width: 90%;	
		display:flex;
	}
	
	
	#customer-logo_nonit{
		padding-bottom: 4px;
	}
	
	#customer-logo_nonit img{
	/* 	width: 100%; */
	    width: 260px;
	}
	
	#customer-logo img{
		width: 100%;
		padding-top: 6%;
		padding-bottom: 6%;
	}
	
	#customer-logo-solo img{
		width: 100%;
		padding-top: 6%;
		padding-bottom: 6%;
	}
	
	#aams-logo{
		width: 45%;
		margin-left:4%;
		display:flex;
	}
	
	#aams-logo img{
		width: 100%;
	}
	.qrcode-container{
		display: grid;
    	justify-content: center;
	}	
	.separator{
		border-bottom: 1px solid black;
		height: 2px;
		width: 100%;
		margin-top: 5px;
		margin-bottom: 5px;
	}
	.separatorBlank{
	    border-bottom: 1px solid white;
	    height: 50px;
	    width: 100%;
	    margin-top: 5px;
	    margin-bottom: 5px;
	    background: #f7f7f7;
	}
	.event_row{
		text-align:center;
		width:100%;
	}
	.date_event{
		float: left;
	    font-size: 8px;
	    padding-top: 2px;
	    font-family: sans-serif;
	    font-weight: bold;
	    display: inline-block;
	    width: 25%;
	    text-align: left;
	}
	
	.event_descr,.bet_descr,.draw_descr,.odd{
		float: left;
	
	}
	
	
	.event_descr{
		text-align: left;
		width: 70%;
	}
	
	.tournament_descr{
	    display: inline-block;
	    width: 70%;
	    float: left;
	    text-align: left;
	    /*margin-left:15%;*/
	}
	
	.banker{
		padding-right: 0.5em;
		/*float: left;*/
		display: inline-block;
	    /*width: 10%;*/
	    width:2%;
		font-size: 9px;
		padding-top: 1px;
	}
	
	.palavv{
	/* 	padding-right: 0.5em; */
		float: left;
		display: inline-block;
	    width: 25%;
		font-size: 8px;
		padding-top: 2px;
		text-align: left;
	}
	
	.avvenimento{
	/* 		padding-bottom: 1em; */
			    margin-top: 3px;
	
	}
	
	
	.ticketType {
		/*font-size: 21px;*/
		font-size: 16px;
	    font-weight: bolder;
	}
	
	.horseRaceNumber {
		margin-top:1%;
		font-size: 25px;
	    font-weight: bolder;
	}
	
	.trisDisclam {
		margin-top:1%;
		font-size: 21px;
	    font-weight: bolder;
	}
	
	.palDisclam {
		margin-top:1%;
		font-size: 21px;
	}
	
	
	.copy{
	    font-size: 17px;
	    /* text-transform: uppercase; */
	    padding-bottom: 3px;
	}
	
	.total_win_text{
		font-size: 13px;
		padding-top: 0.5em;
	}
	
	.total_win{
		font-size: 26px;
	}
	
	.id_ticket_footer{
		font-family: monospace;
		font-size: 17px;
		padding: 5px 0 5px 0;
		font-weight:bold;
	}
	
	.disclaimer{
		font-size: 10px;
	}
	
	.disclaimer_spacing{
		padding: 4px 0 4px 0;
	}
	
	.website{
		font-size: 19px;
	}
	
	/* SISTEMI */
	
	.applicato_bonus_percentuale{
		padding: 1em 0 1em 0;
	}
	
	.combinations{
		font-family: monospace;
		width: 100%;
	    padding-bottom: 5px;
	}
	
	.tournament_row{
		text-align:center;
		font-family: sans-serif;
	    font-weight: bold;
	}
	
	.uppercase{
		text-transform:uppercase;
	}
	
	.textNewLine{
		word-break: break-all;
	}

</style>
`;

export const flashbetTicketStyle = `
	<style>
	* {
	    margin: 0;
	    padding: 0;
	    border: 0;
	    font-size: 100%;
	    font: inherit;
	    vertical-align: baseline;
	}
	html {
	    width: 430px;
	}
	.border-2px {
	    border: 2px solid #000;
	}
	.border-bottom:not(:last-child) {
	    border-bottom: solid 1px #000;
	}
	.border-bottom-dashed:not(:last-child) {
	    border-bottom: 1px dashed #bbb; 
	}
	.border-bottom-none {
	    border-bottom: none;
	}
	.margin-top {
	    margin-top: 1%;
	}
	.container {
	    padding: 1% 2% 1% 1%;
	}
	.fright {
	    float: right;
	}
	.text-align-center {
	    text-align: center;
	}
	.bold {
	    font-weight: bold;
	}
	.italic {
	    font-style: italic;
	}
	.h1 {
	    font-size: 350%;
	}
	.h2 {
	    font-size: 300%;
	}
	.h3 {
	    font-size: 250%;
	}
	.h4 {
	    font-size: 150%;
	}
	.h5 {
	    font-size: 120%;
	}
	.h6 {
	    font-size: 80%;
	}
	.d-flex-container {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}
	.d-flex {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}
	.justify-content-center {
	    justify-content: center;
	}
	.justify-content-space-between {
	    justify-content: space-between;
	}
	#logocliente img, #logoams img {
	    width: 100%;
	}
	.page-break-inside-avoid {
	    page-break-inside: avoid;
	}
	.sans-serif {
	    font-family: sans-serif;
	}
	.hide{
		display:none;
	}
	.td-10 {
	    width: 10%;
	}
	
	.td-15 {
	    width: 15%;
	}
	
	.td-20 {
	    width: 20%;
	}
	
	.td-25 {
	    width: 25%;
	}
	
	.td-30 {
	    width: 30%;
	}
	
	.td-33 {
	    width: 33%;
	}
	
	.td-35 {
	    width: 35%;
	}
	
	.td-40 {
	    width: 40%;
	}
	
	.td-50 {
	    width: 50%;
	}
	
	.td-60 {
	    width: 60%;
	}
	
	.td-66 {
	    width: 66%;
	}
	
	.td-70 {
	    width: 70%;
	}
	
	.td-75 {
	    width: 75%;
	}
	
	.td-80 {
	    width: 80%;
	}
	
	.td-85 {
	    width: 85%;
	}
	
	.td-100 {
	    width: 100%;
	}
	
	.left {
	    float: left;
	}
	
	.right {
	    float: right;
	}
	
	.center {
	    text-align: center;
	}
	
	.textleft {
	    text-align: left;
	}
	
	.textcenter {
	    text-align: center;
	}
	
	.textright {
	    text-align: right;
	}
	#tabella-superiore{
		width: 96%;
		margin-left: 2%;
		margin-bottom: 3%;
	}
</style>
`;

export const printScript =`
	<script type="text/javascript">
		 function getFormattedFullTimestamp() {
			try {
				const pad = (n,s=2) => (''+new Array(s).fill(0)+''+n).slice(-s);
				const d = new Date();
				
				return ''+pad(d.getFullYear(),4)+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())+' '+pad(d.getHours())+':'+pad(d.getMinutes())+':'+pad(d.getSeconds())+'.'+pad(d.getMilliseconds(),3);
			
			}catch(err) {
				console.error(err);
			}
		}
	</script>
	<script type="text/javascript">
		window.idTicket = '{{ID_TICKET}}';
		window.PRINT_STATUS = "NOT_STARTED"; 
		console.debug(getFormattedFullTimestamp()+" [IFRAME PRINTER] " + window.idTicket + "PRINT NOT STARTED");
		(function() {
		    var beforePrint = function(media) {
			   window.PRINT_STATUS = "PENDING";
		       console.debug(getFormattedFullTimestamp()+" [IFRAME PRINTER]" +"[MEDIA="+media+"]" +window.idTicket + " PRINT " +window.PRINT_STATUS);
		    };
			const afterPrintTimeout = setTimeout(function() { 
											console.debug(getFormattedFullTimestamp()+ " [IFRAME PRINTER] afterPrint for " + window.idTicket + " not triggered -> forcing it "); 
											afterPrint() }, 
										10000);
		    var afterPrint = function(media) {
				window.PRINT_STATUS = "DONE";
				console.debug(getFormattedFullTimestamp()+" [IFRAME PRINTER]" +"[MEDIA="+media+"]"  +window.idTicket + " PRINT " +window.PRINT_STATUS);
				if(afterPrintTimeout) {
					console.debug(getFormattedFullTimestamp()+ " [IFRAME PRINTER]" +"[MEDIA="+media+"] clearTimeout afterPrint for " + window.idTicket); 
					clearTimeout(afterPrintTimeout);
				}
		    };

			window.onbeforeprint = beforePrint;
		    window.onafterprint = afterPrint;
			
			// Sometimes, for unknown reason, onafterprint is not fired. Use window.matchMedia to detect the before and after print 
			// Note that your event handlers might potentially have to deal with the fact that they’re going to be called twice per print request in Chrome.
		    if (window.matchMedia) {
		        var mediaQueryList = window.matchMedia("print");
		        mediaQueryList.addListener(function(mql) {
		        	if (mql.matches) {
		                beforePrint(mql);
		            } else {
		                afterPrint(mql);
		            }
		        });
		    }
			//afterPrintInterval = setInterval(function() { afterPrint() }, 50);
			
		}());
		 function printTicket() {
		 	console.debug(getFormattedFullTimestamp()+" [IFRAME PRINTER] " + window.idTicket + " PRINT START");
			this.window.print(); 
			//return 0;
		 }
	</script>
`;